import $ from 'jquery';

const tabSelect = () => {
  const tabSelectElements = $('[data-toggle="tab-select"]');
  tabSelectElements.each((index, item) => {
    const target = item.getAttribute('href');
    const targetNode = $(target);

    $(item).on('click', (event) => {
      event.preventDefault();
      $(targetNode).tab('show');
      $('#prdctModal').modal('hide');
      $('[data-tab-select]').addClass('d-none');
      $('[data-tab-select="' + target + '"]').removeClass('d-none');
    });
  });
};

export default tabSelect;
